import React, { useRef, useLayoutEffect } from 'react';
import { createPopper, StrictModifiers } from '@popperjs/core';
import { SimpleTooltipProps } from './types';
import { ARROW_OFFSET } from './consts';
require("./SimpleTooltip.css");
var Styles = {
  "simpleTooltip": "SimpleTooltip-module-simpleTooltip_xjn",
  "simpleTooltipArrow": "SimpleTooltip-module-simpleTooltipArrow_31_"
};
export const SimpleTooltip = ({
  className = Styles.simpleTooltip,
  offset = 0,
  flipOffset = 0,
  paddingFromWindow = 0,
  placement,
  children,
  parentElement,
  arrowClassName = Styles.simpleTooltipArrow,
  hasArrow = true
}) => {
  const tooltipContainer = useRef(null);
  const tooltipArrow = useRef(null);
  useLayoutEffect(() => {
    if (tooltipContainer.current !== null) {
      let modifiers = [{
        name: 'offset',
        options: {
          offset: [0, offset + ARROW_OFFSET]
        }
      }, {
        name: 'flip',
        options: {
          padding: flipOffset
        }
      }, {
        name: 'preventOverflow',
        options: {
          padding: paddingFromWindow
        }
      }];
      if (hasArrow && tooltipArrow.current) {
        modifiers.push({
          name: 'arrow',
          options: {
            element: tooltipArrow.current
          }
        });
      }
      createPopper(parentElement, tooltipContainer.current, {
        placement,
        modifiers
      });
    }
  }, [hasArrow, placement, children, parentElement, offset, flipOffset, paddingFromWindow]);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: tooltipContainer
  }, children, hasArrow && /*#__PURE__*/React.createElement("div", {
    className: arrowClassName,
    ref: tooltipArrow
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SimpleTooltip.displayName = 'SimpleTooltip';
}